import { faFileCircleCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import getFilePath from "../utils/getFilePath"


function ResponseFileView({ body}) {
 
  


  return (
    <>
   
                         
                          
<a target="_blank"  className="form__title-row form__input--ltr " href={getFilePath(body)}>
<FontAwesomeIcon className="status--completed" icon={faFileCircleCheck} />

                          <h3 className="status--completed" >
  {body.name}
                          </h3>
                          
                          </a>
                          
                       
                        
    </>
   
  )
}

export default ResponseFileView